/**
 * Layout.js
 *
 * Route wrapper for the staff-only Settings > Videos page. All UI and logic
 * lives in src/features/staff-settings-videos.
 */
import React from 'react';
import { VideosPage } from '@/features/staff-settings-videos';

export default function Layout() {
  return <VideosPage />;
}
